import {
  FormField,
  Input,
  InputProps,
  Multiselect,
  MultiselectProps,
  NonCancelableCustomEvent,
  SelectProps,
} from '@amzn/awsui-components-core';
import React, { useState } from 'react';
interface Props {
  customLabel: string;
  validationError?: string;
  label: string;
  onSelectsUpdated?: (selectedValues: string[], customValue: string) => void;
  onCustomInputUpdated?: (selectedValues: string[], customValue: string) => void;
  customOption: string;
  placeholder?: string;
  selectOptions: SelectProps.Option[];
  stretch?: boolean;
  values?: string;
}

interface ParsedValues {
  selectValues?: string[];
  custValues?: string;
}

const MultiselectCustomInput: React.FunctionComponent<Props> = (props: Props) => {
  const { validationError, onCustomInputUpdated, onSelectsUpdated, customOption, selectOptions } =
    props;
  const selectOpt = selectOptions.map((i) => i.value?.toUpperCase());

  const parseMultiselectValues = (values: string[]) => {
    const selectValues = values.filter(
      (i, ind) => i && selectOpt.includes(i.toUpperCase()) && values.indexOf(i) === ind,
    );
    return selectValues;
  };

  const parseCustomValues = (values: string[]) => {
    const custValues = values
      .filter((i, ind) => i && !selectOpt.includes(i.toUpperCase()) && values.indexOf(i) === ind)
      .join(', ');
    return custValues;
  };

  const parseValues = (values: string): ParsedValues => {
    const valueArr = values.split(',') || [];
    const selectValues = parseMultiselectValues(valueArr);
    const custValues = parseCustomValues(valueArr);
    return { selectValues, custValues };
  };

  const pValues = parseValues(props.values ?? '');
  const [multiSelectedOptions, setMultiSelectedOptions] = useState<SelectProps.Option[]>(
    selectOptions.filter((i) => i.value && pValues.selectValues?.includes(i.value)),
  );
  const [customValues, setCustomValues] = useState<string>(pValues.custValues ?? '');

  const handleSelectInput = (
    event: NonCancelableCustomEvent<MultiselectProps.MultiselectChangeDetail>,
  ) => {
    const selectValues: string[] = event.detail.selectedOptions
      .map((option) => option.value)
      .filter((option) => option !== undefined);
    if (onSelectsUpdated) {
      onSelectsUpdated(selectValues, customValues ?? '');
    }
    setMultiSelectedOptions([...event.detail.selectedOptions]);
  };

  const handleFieldInput = (e: NonCancelableCustomEvent<InputProps.ChangeDetail>) => {
    const custValues: string = e.detail.value;
    const selectedValues: string[] = multiSelectedOptions
      .map((option) => option.value)
      .filter((option) => option !== undefined);
    if (onCustomInputUpdated) {
      onCustomInputUpdated(selectedValues, custValues);
    }
    setCustomValues(custValues);
  };

  const renderSelectValues = () => {
    const { label, placeholder = '', stretch = false } = props;
    return (
      <FormField
        label={<span>{`${label}`}</span>}
        stretch={stretch}
        i18nStrings={{ errorIconAriaLabel: 'Error' }}
      >
        <Multiselect
          selectedOptions={multiSelectedOptions}
          onChange={handleSelectInput}
          options={selectOptions}
          placeholder={placeholder}
          disabled={false}
          filteringType={'auto'}
          keepOpen={false}
          ariaRequired
          deselectAriaLabel={() => 'Remove option'}
          filteringAriaLabel="Filter options"
        />
      </FormField>
    );
  };

  const showCustomValues = () => {
    return (
      multiSelectedOptions.find((option) => option.value === customOption) || customValues !== ''
    );
  };

  const renderCustomValues = () => {
    const { customLabel } = props;
    return (
      <div>
        <FormField
          errorText={validationError}
          label={customLabel}
          stretch
          i18nStrings={{ errorIconAriaLabel: 'Error' }}
        >
          <Input value={customValues ?? ''} onChange={handleFieldInput} ariaRequired />
        </FormField>
      </div>
    );
  };

  return (
    <div className="task-creator-skills">
      {renderSelectValues()}
      {showCustomValues() ? renderCustomValues() : ''}
    </div>
  );
};

export default MultiselectCustomInput;
